var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCloseCircular = function SvgIconCloseCircular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none",
    viewBox: "0 0 36 35"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.498,
    cy: 17.5,
    r: 16.71,
    stroke: "#646567",
    strokeWidth: 1.58,
    opacity: 0.6,
    transform: "rotate(-180 18.498 17.5)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m14.371 22.656-1.03-1.03 9.28-9.281 1.03 1.03z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "m13.34 13.375 1.03-1.031 9.282 9.28-1.031 1.032z"
  })));
};
export { SvgIconCloseCircular as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBvcGFjaXR5PSIwLjYiIGN4PSIxOC40OTgiIGN5PSIxNy41IiByPSIxNi43MTAyIiB0cmFuc2Zvcm09InJvdGF0ZSgtMTgwIDE4LjQ5OCAxNy41KSIgc3Ryb2tlPSIjNjQ2NTY3IiBzdHJva2Utd2lkdGg9IjEuNTc5NTQiLz4KPHJlY3QgeD0iMTQuMzcxMSIgeT0iMjIuNjU2MiIgd2lkdGg9IjEuNDU4MzMiIGhlaWdodD0iMTMuMTI1IiB0cmFuc2Zvcm09InJvdGF0ZSgtMTM1IDE0LjM3MTEgMjIuNjU2MikiIGZpbGw9IiMxODE4MTgiLz4KPHJlY3QgeD0iMTMuMzM5OCIgeT0iMTMuMzc1IiB3aWR0aD0iMS40NTgzMyIgaGVpZ2h0PSIxMy4xMjUiIHRyYW5zZm9ybT0icm90YXRlKC00NSAxMy4zMzk4IDEzLjM3NSkiIGZpbGw9IiMxODE4MTgiLz4KPC9zdmc+Cg==";